document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();
  progressPath.style.transition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;

  // Layout metrics are cached from ResizeObserver so scrolling never forces a synchronous layout.
  let scrollableHeight = 1;
  let lastOffset = null;
  let frame = 0;

  const updateProgress = () => {
    frame = 0;
    const scroll = window.scrollY || window.pageYOffset;
    const offset = pathLength - (Math.min(scroll, scrollableHeight) * pathLength) / scrollableHeight;
    if (offset !== lastOffset) {
      progressPath.style.strokeDashoffset = offset;
      lastOffset = offset;
    }
  };

  const requestUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(updateProgress);
  };

  const measure = () => {
    scrollableHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', measure, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(measure).observe(document.body);
  } else {
    window.requestAnimationFrame(measure);
  }
});
